import React, { Component } from 'react';
import { Row, Col, Form, FormGroup, Label, Input } from 'reactstrap';
import styles from './Entitlement.module.css';
import '../css/TheftLoss.css';
import classNames from 'classnames';
import SimpleReactValidator from 'simple-react-validator';
import SaveModal from '../../../../components/modals/SaveModal';
import moment from 'moment';
import Calendar from 'react-calendar';
import Cleave from 'cleave.js/react';
import { ReactComponent as CalendarIcon } from '../../../../assets/images/calendar.svg';
import { updatePartnerCase } from '../../../../helpers';
import DocumentTitle from 'react-document-title';
import { isMobile } from 'react-device-detect';
import { UseTranslationInClassComponent } from '../../../contexts/LanguageTranslation/UseTranslationInClassComponent';
import IntakeLossButtons from './IntakeLossButtons';
import IncidentDesc from '../../Apple/IntakeLoss/IncidentDesc';
import {
    appleAffirmationsByState,
    defaultEnglishAffirmation,
    getAppleAffirmationStatement
} from './AppleAffirmationsByState';
import { ContractContext } from '../../../contexts/ContractContext';
import PrivacyModal from './PrivacyModal';
import getClientContent from '../../../_BrandingProvider/brandContent';

let cardTitle = styles.cardTitle;
let dateInput = styles.dateInput;
const formError = styles.formError;
const textError = styles.textError;
let mw275 = styles.mw275;
let mb0 = 'mb-0';
let formControl = 'form-control';
let maxLength = styles.maxLength;
let col4 = 'col-4';
let radioControlsLabel = 'radio-controls-label';
let w100 = styles.w100;

export class Entitlement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            symptom: '',
            coverageId: this.props?.history?.location?.state?.entitlementDetails?.coverageId || null,
            contractId: this.props?.contractId,
            tempDate: '',
            showCalendar: false,
            incidentDate: this.props?.history?.location?.state?.entitlementDetails?.incidentDate || '',
            incidentDescription: this?.props.history?.location?.state?.entitlementDetails?.incidentDescription || '',
            clientId: this.props?.history?.location?.state?.entitlementDetails.clientId || 'apple',
            claimNumber:
                this.props?.history?.location?.state?.entitlementDetails?.claimNumber || this.props?.claim?.claimNumber,
            caseNumber:
                this.props?.history?.location?.state?.entitlementDetails?.caseNumber || this.props?.claim?.caseNumber,
            party:
                this.props?.history?.location?.state?.entitlementDetails?.party || this.props?.claim?.replacementParty,
            claimId: this.props?.claimId || this.props?.claim?.claimId,
            contractAssetId: this.props?.contractAssetId,
            continuing: false,
            statusFlag: this.props?.statusFlag,
            validationFired: false,
            affirmed: '',
            pageTitle: `Incident Info | ${getClientContent('apple')?.variableText?.pageTitle}`,
            claimSetupDate: '',
            showPrivacyModal: false,
            claimOverviewVersion: this.props?.claimOverviewVersion || false,
            isMultiplePendingRequest: this.props?.isMultiplePendingRequest || false,
            isValidDate: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleCoverageChange = this.handleCoverageChange.bind(this);
        this.handleCalendarDate = this.handleCalendarDate.bind(this);
        this.handleCleaveDate = this.handleCleaveDate.bind(this);
        this.openCalendar = this.openCalendar.bind(this);
        this.affirmationChange = this.affirmationChange.bind(this);
        this.checkIfError = this.checkIfError.bind(this);
        this.continue = this.continue.bind(this);
        this.submit = this.submit.bind(this);
        this.keepOnPage = this.keepOnPage.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.validator = new SimpleReactValidator({
            validators: {
                affirmation: {
                    rule: (val, params, validator) => {
                        return this.state.affirmed === 'affirmed';
                    },
                    required: true
                },
                valid_date: {
                    rule: (val, params, validator) => {
                        return this.state.isValidDate;
                    },
                    required: true
                }
            },
            element: (message) => (
                <div
                    className='errorMsg'
                    role='alert'
                >
                    {message.charAt(0).toUpperCase() + message.slice(1)}
                </div>
            )
        });
    }

    onSaveForLaterAction = (e) => {
        e.preventDefault();
        console.log('save');
        this.setState({ showConfirmation: true });
    };

    onSaveCancel = (e) => {
        e.preventDefault();
        this.setState({ showConfirmation: false });
        document.getElementById('later-id').focus();
    };

    componentDidMount() {
        window.addEventListener('beforeunload', this.keepOnPage);
        let claim = this.props?.history?.location?.state?.claim || this.props?.claim;
        var setupDate = new Date(claim.claimSetupDate);
        this.setState({
            claimSetupDate: claim.claimSetupDate == null ? '' : setupDate
        });
        let feature = claim?.featureClaimModel;
        let featureIndex = feature?.length - 1;
        if (feature && feature?.length > 0) {
            fetch(
                'api/contract/GetCoverageByContractAssetCoverageId/'
                    .concat(feature[0].contractAssetCoverageId)
                    .concat('/')
                    .concat(
                        this.props.history.location.state.entitlementDetails.contract.contractAssetModel[0]
                            .contractAssetId
                    )
                    .concat('/apple')
            )
                .then((res) => res.json())
                .then((data) => {
                    var lossDate = new Date(claim.lossDate);
                    console.log(data);
                    this.setState({
                        tempDate: claim.lossDate == null ? '' : moment(lossDate).format('MM/DD/YYYY'),
                        incidentDate: claim.lossDate == null ? '' : lossDate,
                        isValidDate: claim.lossDate == null ? false : true,
                        incidentDescription: claim.incidentDescription || '',
                        coverageId: data.coverageId,
                        affirmed: claim.affirmationFlag ? 'affirmed' : ''
                    });
                });

            //var cId = feature[0].contractAssetCoverageId == 1 ? 13 : 14;
        }
        console.log(claim);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.submitting !== this.props?.submitting && this.state.claimOverviewVersion) {
            if (this.props?.submitting) {
                this.submit();
            }
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    };

    affirmationChange = () => {
        if (this.state.affirmed === '') {
            this.setState({ affirmed: 'affirmed' });
        } else {
            this.setState({ affirmed: '' });
        }
    };
    handleCoverageChange = (e) => {
        console.log('hu', e.target);
        this.setState({
            coverageId: parseInt(e.target.value)
        });
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            let { name, value, id } = e.target;

            let checked = false;

            switch (id) {
                case 'reach-skip-nav':
                    checked = document.getElementById('carrier1').checked;
                    break;
                case 'carrier2Div':
                    checked = document.getElementById('carrier2').checked;
                    break;

                case 'otherCarrierCheckboxDiv':
                    checked = document.getElementById('otherCarrier').checked;
                    break;
                default:
                    checked = e.target.checked;
            }

            if (checked === false) {
                switch (id) {
                    case 'otherCarrier':
                    case 'otherCarrierCheckboxDiv':
                        value = 'other';
                        break;
                    case 'reach-skip-nav':
                        value = 13;
                        break;
                    case 'carrier2Div':
                        value = 14;
                        break;
                }
            } else {
                value = null;
            }

            this.setState({
                coverageId: value,
                validated: false
            });
        }
    };

    handleCleaveDate = (e, dateFormat = 'MM/DD/YYYY') => {
        let cleaveDate = e.target.value;
        let momentObj = moment(cleaveDate, dateFormat, true);
        const isValidDate = momentObj.isValid();
        let date;

        if (isValidDate) {
            date = momentObj?.toDate();
        }

        if (isValidDate && !isNaN(date?.getTime())) {
            this.setState({
                tempDate: cleaveDate,
                incidentDate: date,
                isValidDate: true
            });
        } else {
            this.setState({
                tempDate: cleaveDate,
                isValidDate: false
            });
        }

        const dayFirstRegex = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;
        const monthFirstRegex = /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/;
        const yearFirstRegex = /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/;

        const localizedRegex =
            dateFormat === 'DD/MM/YYYY'
                ? dayFirstRegex
                : dateFormat === 'YYYY/MM/DD'
                  ? yearFirstRegex
                  : monthFirstRegex;

        if (this.validator.helpers.testRegex(cleaveDate, localizedRegex)) {
            this.openCalendar(false);
        }
    };

    handleCalendarDate = (e, momentJsFormat) => {
        this.setState({
            tempDate: moment(e).format(momentJsFormat),
            incidentDate: e,
            isValidDate: true
        });

        this.openCalendar(false);
    };

    openCalendar = (e) => {
        //e.preventDefault();

        this.setState({
            showCalendar: e
        });
    };

    checkIfError = (field) => {
        var messages = this.validator.getErrorMessages();
        for (var i = 0; i < messages.length; i++) {
            console.log(messages[i]);
        }
    };

    toISOStringWithoutTimezone = (date) => {
        if (date) {
            const timezoneOffset = date.getTimezoneOffset() * 60 * 1000; // Offset in milliseconds
            const adjustedDate = new Date(date.getTime() - timezoneOffset);
            return adjustedDate.toISOString().slice(0, -1); // Remove the trailing 'Z'
        } else {
            return '';
        }
    };

    continue = () => {
        this.setState({ validationFired: true });

        this.openCalendar(false);

        if (this.validator.allValid()) {
            this.createFeatureClaimAndRunRules();
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    submit = () => {
        this.setState({ validationFired: true });
        this.openCalendar(false);

        if (this.validator.allValid()) {
            const incidentDate = this.toISOStringWithoutTimezone(this.state.incidentDate);
            fetch(`api/claim/UpdateIncidentDescription/${this.state.clientId}`, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    claimId: parseInt(this.state.claimId),
                    PendingInformationRequestId: this.props?.pendingInfoRequestId,
                    RequestClarificationId: this.props?.requestClarificationId,
                    IncidentDescription: this.state.incidentDescription,
                    IncidentDate: incidentDate,
                    Affirmed: this.state.affirmed?.toLowerCase() === 'affirmed',
                    IncidentPlace: this.props?.claim?.replacementParty?.shippingAddress?.city,
                    CountryCode: this.props?.claim?.replacementParty?.shippingAddress?.countryCode
                })
            }).then((res) => {
                if (res.ok) {
                    if (res.status === 200) {
                        res.json().then((data) => {
                            if (!this.state.isMultiplePendingRequest) {
                                this.props?.updateClaimOverviewStatus('incidentDescription', true);
                            } else if (this.state.isMultiplePendingRequest) {
                                this.props?.updateClaimOverviewStatus('incidentDescription', false);
                            }
                        });
                    }
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
            this.props?.stopPageProgression();
        }
    };

    createFeatureClaimAndRunRules() {
        console.log(
            'enter',
            this.props.history.location.state.entitlementDetails,
            this.state.clientId,
            this.state.isSaveForLater
        );
        if (this.validator.allValid() || this.state.isSaveForLater) {
            const incidentDate = this.toISOStringWithoutTimezone(this.state.incidentDate);
            let entitlementDetails = this.props.history.location.state.entitlementDetails;
            this.setState({ continuing: true });

            //update partner case
            updatePartnerCase(entitlementDetails.claimNumber, 'ASCH', this.state.clientId);

            let claim = this.props.history.location.state.claim;
            console.log(claim, this.props);
            claim.incidentDescription = this.state.incidentDescription;
            claim.lossDate = incidentDate;
            claim.coverageId = this.state.coverageId;
            claim.affirmationFlag = this.state.affirmed === 'affirmed';

            if (this.state.coverageId == null && this.state.isSaveForLater) {
                this.saveForLaterAction(claim, false);
                return;
            }
            fetch('api/claim/featureclaim/'.concat(entitlementDetails.claimId), {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    claimId: entitlementDetails.claimId,
                    coverageId: this.state.coverageId == null ? 1 : this.state.coverageId,
                    incidentDescription: this.state.incidentDescription,
                    incidentDate: incidentDate,
                    clientId: this.state.clientId,
                    contractAssetId:
                        entitlementDetails.contractAsset.contractAssetId
                        || entitlementDetails.contractAsset.contractAssetModel[0].contractAssetId,
                    affirmed: this.state.affirmed === 'affirmed',
                    FeatureClaimStatus: this.state.isSaveForLater ? 3 : 8,
                    claimSetupDate: this.state.claimSetupDate
                })
            }).then((res) => {
                if (res.ok) {
                    res.json().then((data) => {
                        let partyId = data?.eventModel[0]?.partyId;
                        let partyEmail = entitlementDetails.partyEmail;
                        let partyPhone = entitlementDetails.partyPhone;
                        let emailModel = [];
                        let phoneModel = [];
                        let email = {
                            address: partyEmail,
                            contactPhone: partyPhone,
                            createdBy: 'CustomerPortal',
                            partyId: partyId,
                            IsPrimary: true
                        };
                        let phone = { partyId: partyId, phoneTypeId: 2, number: partyPhone, IsPrimary: true };
                        emailModel.push(email);
                        phoneModel.push(phone);
                        fetch('api/party/UpdatePartyPhoneAndEmail/'.concat(partyId, '/').concat(this.state.clientId), {
                            method: 'put',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                partyId: partyId,
                                partyPhoneModel: phoneModel,
                                partyEmailModel: emailModel
                            })
                        }).then((res) => {
                            if (res.ok) {
                                if (this.state.isSaveForLater) {
                                    this.saveForLaterAction(claim, false);
                                    return;
                                }
                                if (res.status === 200) {
                                    res.json().then((party) => {
                                        this.setState({ continuing: false });
                                        console.log(this.props);
                                        this.props.history.push('/vendor/apple/verifyinfo', {
                                            entitlementDetails: {
                                                caseNumber: entitlementDetails.caseNumber,
                                                contract: entitlementDetails.contract,
                                                contractAsset: entitlementDetails.contractAsset,
                                                claimId: entitlementDetails.claimId,
                                                claimNumber: entitlementDetails.claimNumber,
                                                partyPhone: entitlementDetails.partyPhone,
                                                party: party,
                                                deductible: entitlementDetails.deductible,
                                                incidentDescription: this.state.incidentDescription,
                                                incidentDate: incidentDate,
                                                coverageId: this.state.coverageId,
                                                clientId: this.state.clientId,
                                                countryCode:
                                                    this.props.history.location.state.entitlementDetails?.countryCode
                                                    ?? 'us',
                                                claimSetupDate: this.state.claimSetupDate,
                                                shipToCountryCode: entitlementDetails?.shipToCountryCode
                                            },
                                            claim: this.props.history.location.state.claim
                                        });
                                    });
                                } else {
                                    this.props.history.push('/vendor/apple/error', {
                                        entitlementDetails: this.props?.history?.location?.state?.entitlementDetails,
                                        claim: this.props?.history?.location?.state?.claim,
                                        path: window.location.pathname?.toLowerCase(),
                                        isFNOLSystemError: true
                                    });
                                    this.setState({ continuing: false });
                                }
                            }
                        });
                    });
                } else {
                    this.props.history.push('/vendor/apple/error', {
                        entitlementDetails: this.props?.history?.location?.state?.entitlementDetails,
                        claim: this.props?.history?.location?.state?.claim,
                        path: window.location.pathname?.toLowerCase(),
                        isFNOLSystemError: true
                    });
                    this.setState({ continuing: false });
                }
            });
        } else {
            console.log(this.validator.getErrorMessages());
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.keepOnPage);
    }
    keepOnPage(e) {
        // Cancel the event as stated by the standard.
        e.preventDefault();
        // Chrome requires returnValue to be set.
        e.returnValue = '';

        let headers = {
            type: 'application/json'
        };

        let claim = this.props?.history?.location?.state?.claim;
        console.log('closing');
        this.saveForLaterAction(claim, true);
    }

    saveForLater = (e) => {
        e && e.preventDefault();
        this.setState({ isSaveForLater: true }, () => {
            this.createFeatureClaimAndRunRules();
        });
    };

    saveForLaterAction = (claim, claimAbandoned) => {
        if (!claim) {
            return;
        }
        this.setState({ uploading: true });
        claim.lossDate = claim.lossDate == '' ? null : claim.lossDate;
        console.log(this.props, claim);
        const entitlementDetails = this.props.history.location.state.entitlementDetails;
        const partyModel = entitlementDetails.party;
        const model = {
            claimModel: claim,
            partyModel: claimAbandoned ? null : partyModel
        };

        fetch(`api/claim/SaveForLater/${claim.claimId}/1/${claimAbandoned}/apple`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(model)
        }).then((data) => {
            if (data.status === 204) {
            }
            if (data.status === 200 && !claimAbandoned) {
                this.props.history.push('/vendor/apple/confirmation', {
                    statusType: 'savedClaim',
                    caseNumber: claim.clientClaimNumber,
                    claimEmail: this.state.party.partyEmailModel[0]?.address
                });
            }
            this.setState({ uploading: false });
        });
    };

    togglePrivacyModal = () => {
        this.setState({ showPrivacyModal: !this.state.showPrivacyModal });
    };

    render() {
        const { pageTitle, validationFired, coverageId, tempDate, isValidDate, incidentDescription, showPrivacyModal } =
            this.state;
        const {
            data: { isChileApple }
        } = this.context;

        return (
            <DocumentTitle title={pageTitle}>
                <UseTranslationInClassComponent
                    componentPathFromSrcFolder={'components/Vendor/Apple/IntakeLoss/Entitlement'}
                >
                    {(international) => {
                        const {
                            country,
                            language,
                            countryVars: {
                                date: { cleavePattern, delimiter, momentJsFormat }
                            },
                            translations
                        } = international;

                        const getAffirmation = () => {
                            const serviceState =
                                this.props.history?.location?.state?.entitlementDetails?.party?.serviceAddress?.state;

                            // prefix prepends all US-ENGLISH affirmations for states with their own affirmation statements.
                            const messagePrefix =
                                'To complete your claim you affirm that the information you have provided regarding your claim is true and accurate: ';
                            const stateMessage = appleAffirmationsByState[serviceState];
                            const joinedPrefixAndCustom = stateMessage && messagePrefix + stateMessage;

                            switch (country) {
                                case 'AU':
                                case 'AUS':
                                    return (
                                        <span>
                                            I declare (i) I have read and accepted the terms of the claims
                                            <a
                                                href='https://www.aig.com.au/privacy'
                                                target='blank'
                                            >
                                                {' '}
                                                privacy notice
                                            </a>
                                            ; and (ii) the information provided to be true in every respect to the best
                                            of our knowledge and belief and that any information provided which is false
                                            or untrue may result in no coverage for the claim and or cancellation of
                                            cover.
                                        </span>
                                    );
                                case 'US':
                                    return joinedPrefixAndCustom || defaultEnglishAffirmation;
                                case 'DE':
                                case 'ES':
                                case 'FR':
                                case 'IT':
                                case 'GB':
                                case 'UK':
                                case 'CL':
                                case 'NZ':
                                case 'AT':
                                case 'DK':
                                case 'FI':
                                case 'IE':
                                case 'NL':
                                case 'NO':
                                case 'SE':
                                case 'CH':
                                case 'JP':
                                case 'MX':
                                case 'IN':
                                default:
                                    return translations.affirmation || defaultEnglishAffirmation;
                            }
                        };
                        return (
                            <>
                                <Form>
                                    {!this.state.claimOverviewVersion && (
                                        <fieldset
                                            id={styles.symptom}
                                            className='form-group'
                                            role='group'
                                        >
                                            <legend
                                                className={classNames(
                                                    styles.cardTitle,
                                                    !coverageId && validationFired && textError
                                                )}
                                                aria-label={
                                                    translations.whatTypeOfIncidentAria
                                                    || 'Select an incident from the list'
                                                }
                                                for='symptomGroup'
                                            >
                                                {translations.whatTypeOfIncident
                                                    || 'What type of incident did you experience?'}
                                                <span
                                                    aria-hidden='true'
                                                    className='required-indicator'
                                                >
                                                    *
                                                </span>
                                            </legend>
                                            <Row className='formBlock'>
                                                <Col>
                                                    <Row className={styles.symptomGroup}>
                                                        <Col
                                                            md='3'
                                                            xs='6'
                                                        >
                                                            <div
                                                                className='radioButton customRadio'
                                                                role='radio'
                                                                aria-checked={
                                                                    this.state.coverageId === 13 ? 'true' : 'false'
                                                                }
                                                                tabIndex='0'
                                                                id='reach-skip-nav'
                                                                onKeyPress={this.handleKeyDown}
                                                            >
                                                                <Input
                                                                    type='radio'
                                                                    aria-label={translations.theftAria || 'theft'}
                                                                    name={'symptom' + this.props.claimId}
                                                                    id={'carrier1'}
                                                                    value={13}
                                                                    onKeyPress={this.handleKeyDown}
                                                                    checked={this.state.coverageId === 13}
                                                                    onChange={this.handleCoverageChange}
                                                                />
                                                                <Label
                                                                    id='theft'
                                                                    className={classNames(
                                                                        radioControlsLabel,
                                                                        w100,
                                                                        !coverageId && validationFired && formError
                                                                    )}
                                                                    for={'carrier1'}
                                                                >
                                                                    {translations.theft || 'Theft'}
                                                                </Label>
                                                            </div>
                                                        </Col>
                                                        <Col
                                                            md='3'
                                                            xs='6'
                                                        >
                                                            <div
                                                                className='radioButton customRadio'
                                                                role='radio'
                                                                aria-checked={
                                                                    this.state.coverageId === 14 ? 'true' : 'false'
                                                                }
                                                                tabIndex='0'
                                                                id='carrier2Div'
                                                                onKeyPress={this.handleKeyDown}
                                                            >
                                                                <Input
                                                                    type='radio'
                                                                    aria-label={translations.lossAria || 'loss'}
                                                                    name={'symptom' + this.props.claimId}
                                                                    id='carrier2'
                                                                    value={14}
                                                                    onKeyPress={this.handleKeyDown}
                                                                    checked={this.state.coverageId === 14}
                                                                    onChange={this.handleCoverageChange}
                                                                />
                                                                <Label
                                                                    id='loss'
                                                                    className={classNames(
                                                                        radioControlsLabel,
                                                                        w100,
                                                                        !coverageId && validationFired && formError
                                                                    )}
                                                                    for={'carrier2'}
                                                                >
                                                                    {translations.loss || 'Loss'}
                                                                </Label>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {this.validator.message(
                                                        'symptom',
                                                        this.state.coverageId,
                                                        'required',
                                                        {
                                                            messages: {
                                                                required:
                                                                    translations.errors?.symptom || 'Required field.'
                                                            }
                                                        }
                                                    )}
                                                </Col>
                                            </Row>
                                        </fieldset>
                                    )}
                                    <div id='incidentDate'>
                                        <FormGroup>
                                            <Label
                                                for='incidentDateInput'
                                                className={classNames(
                                                    styles.cardTitle,
                                                    (!tempDate || !isValidDate) && validationFired && textError
                                                )}
                                            >
                                                {translations.whenOccurred || 'When did it happen?'}
                                                <span
                                                    aria-hidden='true'
                                                    className='required-indicator'
                                                >
                                                    *
                                                </span>
                                            </Label>
                                            <Row className='formBlock'>
                                                <Col
                                                    className={classNames(
                                                        styles.mw275,
                                                        'd-sm-block',
                                                        'd-md-block',
                                                        'd-lg-block',
                                                        'd-xl-block'
                                                    )}
                                                >
                                                    <div
                                                        className={classNames('input-group')}
                                                        aria-required='true'
                                                        aria-current='date'
                                                        aria-label={moment().format('MMM Do YYYY')}
                                                    >
                                                        <Cleave
                                                            onFocus={() => this.openCalendar(true)}
                                                            aria-current='date'
                                                            aria-label={moment().format('MMM Do YYYY')}
                                                            inputMode='numeric'
                                                            className={classNames(
                                                                formControl,
                                                                dateInput,
                                                                (!tempDate || !isValidDate)
                                                                    && validationFired
                                                                    && formError
                                                            )}
                                                            name='incidentDate'
                                                            id='incidentDateInput'
                                                            placeholder={momentJsFormat?.toLowerCase() || 'mm/dd/yyyy'}
                                                            value={this.state.tempDate}
                                                            onChange={(e) => this.handleCleaveDate(e, momentJsFormat)}
                                                            onKeyDown={(e) =>
                                                                e.keyCode === 27 && this.openCalendar(false)
                                                            }
                                                            options={{
                                                                date: true,
                                                                delimiter: delimiter,
                                                                datePattern: cleavePattern,
                                                                dateMax: moment().format('YYYY-MM-DD')
                                                            }}
                                                        />
                                                        <CalendarIcon
                                                            role='button'
                                                            tabIndex={0}
                                                            className={classNames(
                                                                styles.datePicker,
                                                                (!tempDate || !isValidDate)
                                                                    && validationFired
                                                                    && formError
                                                            )}
                                                            name='calendarIcon'
                                                            onClick={() => this.openCalendar(!this.state.showCalendar)}
                                                        />
                                                        {this.state.showCalendar && (
                                                            <Calendar
                                                                name='incidentDate'
                                                                aria-current='date'
                                                                aria-label={moment().format('MMM Do YYYY')}
                                                                autocomplete='off'
                                                                value={this.state.incidentDate}
                                                                onChange={(e) =>
                                                                    this.handleCalendarDate(e, momentJsFormat)
                                                                }
                                                                maxDate={new Date()}
                                                                minDate={
                                                                    new Date(
                                                                        new Date().setFullYear(
                                                                            new Date().getFullYear() - 1
                                                                        )
                                                                    )
                                                                }
                                                                locale={`${language}-${country == 'AUS' ? 'AU' : country}`}
                                                            />
                                                        )}
                                                    </div>
                                                    {this.validator.message(
                                                        'incidentDate',
                                                        this.state.tempDate,
                                                        'required|valid_date|future_date',
                                                        {
                                                            messages: {
                                                                required:
                                                                    translations.errors?.date
                                                                    || 'Incident date is required.',
                                                                valid_date:
                                                                    translations.errors?.date
                                                                    || 'Incident date is required.'
                                                            }
                                                        }
                                                    )}
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </div>
                                    <div id='incidentDescription'>
                                        <FormGroup
                                            className={!incidentDescription && validationFired ? 'form-error' : ''}
                                        >
                                            <Label
                                                for='incidentDescInput'
                                                className={classNames(
                                                    styles.description,
                                                    !this.state.incidentDescription && validationFired && textError
                                                )}
                                            >
                                                <>
                                                    {translations?.description
                                                        || 'To expedite your claim processing, provide a detailed description of the events that occurred when the device was lost or stolen, such as:'}
                                                    <span
                                                        aria-hidden='true'
                                                        className='required-indicator'
                                                    >
                                                        *
                                                    </span>
                                                    <ul className='mb-0'>
                                                        <li>
                                                            {translations?.descriptionInfo
                                                                || 'Where and how did it happen?'}
                                                        </li>
                                                        <li>{translations?.eventInfo || 'What events took place?'}</li>
                                                        <li className='font-weight-bold'>
                                                            {translations?.specificInfo
                                                                || 'Be as specific as possible.'}
                                                        </li>
                                                    </ul>
                                                </>
                                            </Label>
                                            <Row className='formBlock'>
                                                <Col
                                                    md='10'
                                                    lg='12'
                                                >
                                                    <IncidentDesc
                                                        handleChange={this.handleChange}
                                                        incidentDescription={this.state.incidentDescription}
                                                        charsRemainingPrefix={translations?.charsRemainingPrefix}
                                                        charsRemainingSuffix={translations?.charsRemainingSuffix}
                                                        charRemainingText={translations?.descriptionCharactersRemaining}
                                                        placeHolder={translations?.descriptionPlaceholder}
                                                        maxLength={1000}
                                                        language={language}
                                                    />
                                                    {this.validator.message(
                                                        'incidentDescription',
                                                        this.state.incidentDescription,
                                                        'required',
                                                        {
                                                            messages: {
                                                                required:
                                                                    translations.errors?.description
                                                                    || 'Incident description is required.'
                                                            }
                                                        }
                                                    )}
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </div>
                                    <Row
                                        id='affirm'
                                        className='formBlock'
                                    >
                                        <Col>
                                            <div className='checkbox scriptBox'>
                                                <Input
                                                    className='mr-2'
                                                    type='checkbox'
                                                    id={'affirmStatement' + this.props.claimId}
                                                    name='affirmationStatement'
                                                    onChange={this.affirmationChange}
                                                    tabIndex='0'
                                                    checked={this.state.affirmed === 'affirmed'}
                                                    aria-required='true'
                                                    aria-label={translations.affirmationAria || 'To complete claim'}
                                                    className={!this.state.affirmed && validationFired && formError}
                                                />
                                                <Label
                                                    for={'affirmStatement' + this.props.claimId}
                                                    className={`checkboxLabel ${isChileApple ? 'southbridge' : ''}`}
                                                >
                                                    {getAffirmation()}
                                                </Label>
                                                {this.validator.message(
                                                    'affirmationStatement',
                                                    this.state.affirmed,
                                                    'affirmation',
                                                    {
                                                        messages: {
                                                            affirmation:
                                                                translations.errors?.affirmation
                                                                || 'Please affirm the information provided is true and accurate.'
                                                        }
                                                    }
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                    {country?.toLowerCase() === 'nz' ? (
                                        <Row className='m-0'>
                                            <div className='mb-4'>
                                                By continuing to file your claim you consent to AIG collecting, holding,
                                                and using your personal information in accordance with the Privacy Act
                                                2020 for the purpose of administering your claim, as described
                                                <a
                                                    onClick={this.togglePrivacyModal}
                                                    className={`btnLink`}
                                                >
                                                    {' '}
                                                    here.
                                                </a>
                                            </div>
                                        </Row>
                                    ) : null}
                                </Form>
                                <Row>
                                    {!this.state.claimOverviewVersion && (
                                        <IntakeLossButtons
                                            // PRIMARY BUTTON PROPS
                                            buttonText={translations.continue || 'Continue'}
                                            onButtonClick={this.continue}
                                            buttonDisabled={this.state.continuing}
                                            buttonSpinning={this.state.continuing}
                                            buttonAriaLabel={
                                                translations.intakeContinueAria
                                                || 'Click continue to proceed to the shipping details step'
                                            }
                                            // FIRST LINK UNDER BUTTON
                                            showLink1={true}
                                            onLink1Click={this.onSaveForLaterAction}
                                            link1AriaLabel={
                                                translations.saveBtnAria || 'Opens a modal to save your claim'
                                            }
                                            link1Text={translations.save || 'Save For Later'}
                                            link1Id='later-id'
                                            // CANCEL LINK PROPS CONTROL CANCEL MODAL
                                            saveClaimClickActionFromWithinCancelModal={this.onSaveForLaterAction}
                                            caseNumberToCancel={this.state.caseNumber}
                                            claimNumberToCancel={this.state.claimNumber}
                                        />
                                    )}
                                    {this.state.showConfirmation && (
                                        <SaveModal
                                            isOpen={this.state.showConfirmation}
                                            aria-label={translations.saveBtnAria || 'Opens a modal to save your claim'}
                                            showConfirmation={this.state.showConfirmation}
                                            history={this.props.history}
                                            continuing={this.state.isSaveForLater}
                                            onCancel={this.onSaveCancel}
                                            onSaveForLaterAction={this.saveForLater}
                                            client={'apple'}
                                        />
                                    )}
                                    {showPrivacyModal && (
                                        <PrivacyModal
                                            showPrivacyModal={showPrivacyModal}
                                            togglePrivacyModal={this.togglePrivacyModal}
                                        />
                                    )}
                                </Row>
                            </>
                        );
                    }}
                </UseTranslationInClassComponent>
            </DocumentTitle>
        );
    }
}

Entitlement.contextType = ContractContext;
